"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var _default = {
  PropTypes: {
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    validateStatus: (0, _propTypes.oneOf)([_constant2.VALIDATE_STATUS_SUCCESS, _constant2.VALIDATE_STATUS_ERROR, _constant2.VALIDATE_STATUS_WARNING]),
    validateMessage: _propTypes.default.string,
    theme: _propTypes.default.string,
    icon: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    selectTextOnFocus: _propTypes.default.bool,
    onFocus: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    onChange: _propTypes.default.func,
    onClick: _propTypes.default.func,
    type: _propTypes.default.string,
    alwaysShowLabel: _propTypes.default.bool,
    showIcon: _propTypes.default.bool,
    hideBorder: _propTypes.default.bool,
    variableWidth: _propTypes.default.string,
    variableHeight: _propTypes.default.string,
    labelMarginBottomLarge: _propTypes.default.bool,
    alignContentRight: _propTypes.default.bool,
    gtmParameters: _propTypes.default.object,
    fireGtm: _propTypes.default.func,
    prefix: _propTypes.default.string,
    forceUpperCase: _propTypes.default.bool,
    borderRadius: _propTypes.default.string,
    innerRef: _propTypes.default.any,
    isDate: _propTypes.default.bool,
    width: _propTypes.default.string,
    containerBoxSizing: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    onFocus: function onFocus() {},
    onBlur: function onBlur() {},
    onChange: function onChange() {},
    onClick: function onClick() {},
    type: 'text',
    alwaysShowLabel: false,
    showIcon: true,
    labelMarginBottomLarge: false,
    alignContentRight: false,
    forceUpperCase: false,
    isDate: false
  }
};
exports.default = _default;